

































































import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import G01IconRanking from "@/general/components/pages/parts/Ranking/G01IconRanking.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    ItemListPanel,
    G01IconRanking,
    IconBase,
    IconArrowBottom,
    ButtonMain
  }
})
export default class G01ItemList extends Vue {
  @Prop({ type: Array, required: true }) items!: any;
  @Prop({ type: Boolean, required: true, default: true }) isCategory!: boolean;

  isAll = false;

  get colorCode() {
    return commons?.OrgPageSpecific?.page_color;
  }

  get current() {
    return function(key: any) {
      return key + 1;
    };
  }
  get max() {
    return this.isAll ? 10 : 4;
  }

  showAll() {
    this.isAll = true;
  }

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });
  }
  getColor(stock: any) {
    return stock > 0 ? commons.colorCode : "#333";
  }
}
